import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import AccountSummaryPage, { getDefaultPageUI } from "components/pages/AccountSummaryPage";

export default function CaptureMabiAccountsExpandeBills(props) {
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ "paymentsWidgeteBills", "isActive"], true)
    .submit();

    return <AccountSummaryPage ui={ ui } />
}